import { useState, useEffect } from 'react';
import { ref, onValue } from '../lib/firebase-database';
import { db } from '../firebase';

export function useAdminQueryCount() {
  const [newQueryCount, setNewQueryCount] = useState(0);
  const [viewedQueries, setViewedQueries] = useState(new Set());

  useEffect(() => {
    const queriesRef = ref(db, 'queries');
    
    const unsubscribe = onValue(queriesRef, (snapshot) => {
      const queries = snapshot.val();
      if (!queries) return;

      const count = Object.entries(queries).reduce((acc, [id, query]) => {
        if (!viewedQueries.has(id) && !query.viewed) {
          return acc + 1;
        }
        return acc;
      }, 0);

      setNewQueryCount(count);
    });

    return () => unsubscribe();
  }, [viewedQueries]);

  const markQueriesAsViewed = (queryIds) => {
    setViewedQueries(prev => new Set([...prev, ...queryIds]));
  };

  return { newQueryCount, markQueriesAsViewed };
}